import React from 'react';
import { Result, Button } from 'antd';
import styled from 'styled-components';

const StyledResult = styled(Result)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const NotFoundPage = () => {
  return (
    <StyledResult
      status="404"
      title="404"
      subTitle={'Page does not exist'}
      extra={
        <Button type="primary" href="/">
          Back
        </Button>
      }
    />
  );
};

export default NotFoundPage;
